"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-twelve/sections/testPlanSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type TestPlanSection4sItem = {
    key: Key | null | undefined;
    /** Detected variants: "plan-item-twelve wow fadeInUp" | "plan-item-twelve two wow fadeInUp" | "plan-item-twelve three wow fadeInUp" */
    className: string;
    /** Detected variants: "1s" | "2s" | "3s" */
    dataWowDuration: string;
    /** Detected variants: "View All" | "View Packages" | "View Services" */
    link0Text: ReactNode;
    /** Detected variants: "Reliable Reports" | "Lab Packages" | "Expert Lab Services" */
    h30Text: ReactNode;
    /** Detected variants: "Accurate Diagnostics at your hospital grade fingertips." | "Affordable packages carefully designed by experts." | "Advanced skilled technicians ensure precise outcomes." */
    p0Text: ReactNode;
    /** Detected variants: "img-fluid\ticon-1" | "img-fluid icon-1" */
    imageWithBasePath0ClassName: string;
    /** Detected variants: "/Templates/Doccure/img/icons/plan-icon-1.svg" | "/Templates/Doccure/img/icons/plan-icon-2.svg" | "/Templates/Doccure/img/icons/plan-icon-3.svg" */
    src: string;
    /** Detected variants: "/Templates/Doccure/img/doctor-grid/plan-img-1.png" | "/Templates/Doccure/img/doctor-grid/plan-img-2.png" | "/Templates/Doccure/img/doctor-grid/plan-img-3.png" */
    imageWithBasePath1Src: string;
    /** Detected variants: "col-lg-4" */
    divClassName?: string;
    /** Detected variants: "plan-content" */
    div0ClassName?: string;
    /** Detected variants: "view-all" */
    div0ClassName2?: string;
    /** Detected variants: "btn btn-white" */
    link0ClassName?: string;
    /** Detected variants: "#" */
    href?: string;
    /** Detected variants: "isax isax-arrow-right-1" */
    i0ClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "description" */
    p0ClassName?: string;
    /** Detected variants: "icon" */
    alt?: string;
    /** Detected variants: "icon" */
    imageWithBasePath1Alt?: string;
    /** Detected variants: "img-fluid plan-img-1" */
    imageWithBasePath1ClassName?: string;
};
export type HomeTwelveTestPlanSectionGeneratedProps = {
    divDiv0Div0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: TestPlanSection4sItem) => Partial<ComponentProps<typeof SmartLink>>);
    divDiv0Div0H30H3Props?: Partial<ComponentProps<"h3">> | ((item: TestPlanSection4sItem) => Partial<ComponentProps<"h3">>);
    divDiv0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TestPlanSection4sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TestPlanSection4sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    /** Default: "1s" */
    sectionDiv0Div0DivDataWowDuration?: string;
    /** Default: "Popular" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    /** Default: "for Your Needs" */
    sectionDiv0Div0H20H2Text2?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Test Plans" */
    sectionDiv0Div0H20Span0SpanText?: ReactNode;
    /** Default: "Discover our most trusted & essential test packages to meet every individual’s needs." */
    sectionDiv0Div0P0PText?: ReactNode;
    sectionDiv0Div1ClassName?: string;
    testPlanSection4s: TestPlanSection4sItem[];
    testPlanSection4sItemWrapper?: (item: TestPlanSection4sItem, content: ReactNode) => ReactNode;
    testPlanSection4sRenderer?: (defaultNode: ReactNode) => ReactNode;
    testPlanSection4sLinkVisible?: boolean;
    testPlanSection4sLinkRenderer?: (item: TestPlanSection4sItem, defaultNode: ReactNode) => ReactNode;
    testPlanSection4sImageVisible?: boolean;
    testPlanSection4sImageRenderer?: (item: TestPlanSection4sItem, defaultNode: ReactNode) => ReactNode;
    testPlanSection4sH3Visible?: boolean;
    testPlanSection4sH3Renderer?: (item: TestPlanSection4sItem, defaultNode: ReactNode) => ReactNode;
    testPlanSection4sLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: TestPlanSection4sItem) => Partial<ComponentProps<typeof SmartLink>>);
    testPlanSection4sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TestPlanSection4sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    testPlanSection4sH3Props?: Partial<ComponentProps<"h3">> | ((item: TestPlanSection4sItem) => Partial<ComponentProps<"h3">>);
};

const HomeTwelveTestPlanSectionGenerated: FC<HomeTwelveTestPlanSectionGeneratedProps> = ({
    sectionDiv0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0H20H2Text = "Popular",
    sectionDiv0Div0H20H2Text2 = "for Your Needs",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0H20Span0SpanText = "Test Plans",
    sectionDiv0Div0P0PText = "Discover our most trusted & essential test packages to meet every individual’s needs.",
    divDiv0Div0Div0Link0LinkProps,
    divDiv0Div0H30H3Props,
    divDiv0ImageWithBasePath0ImageProps,
    divDiv0ImageWithBasePath1ImageProps,
    sectionDiv0Div1ClassName,
    testPlanSection4s,
    testPlanSection4sItemWrapper,
    testPlanSection4sRenderer,
    testPlanSection4sLinkVisible,
    testPlanSection4sLinkRenderer,
    testPlanSection4sImageVisible,
    testPlanSection4sImageRenderer,
    testPlanSection4sH3Visible,
    testPlanSection4sH3Renderer,
    testPlanSection4sLinkProps,
    testPlanSection4sImageProps,
    testPlanSection4sH3Props,
}) => {
    return (
        <section className="plans-section-twelve section">
            <div className="container">
                <div className="section-header section-header-twelve text-center wow fadeInUp" data-wow-duration={sectionDiv0Div0DivDataWowDuration}>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>
                            {" "}
                            {sectionDiv0Div0H20H2Text}
                            <span className="text-primary">{sectionDiv0Div0H20Span0SpanText}</span>
                            {sectionDiv0Div0H20H2Text2}
                            {" "}
                        </h2>
                    ))}
                    <p className="description">{sectionDiv0Div0P0PText}</p>
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row g-4"}>
                    {renderCollectionNode(
                        testPlanSection4s,
                        (item: TestPlanSection4sItem) => (
                            <div className={item.divClassName ?? "col-lg-4"} key={item.key}>
                                <div className={item.className} data-wow-duration={item.dataWowDuration}>
                                    <div className={item.div0ClassName ?? "plan-content"}>
                                        {renderItemNode(testPlanSection4sH3Visible, testPlanSection4sH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof testPlanSection4sH3Props === "function" ? testPlanSection4sH3Props(item) : (testPlanSection4sH3Props ?? {}))} {...(typeof divDiv0Div0H30H3Props === "function" ? divDiv0Div0H30H3Props(item) : (divDiv0Div0H30H3Props ?? {}))}>{item.h30Text}</h3>
                                        ))}
                                        <p className={item.p0ClassName ?? "description"}>{item.p0Text}</p>
                                        <div className={item.div0ClassName2 ?? "view-all"}>
                                            {renderItemNode(testPlanSection4sLinkVisible, testPlanSection4sLinkRenderer, item, (
                                                <SmartLink href={item.href ?? "#"} className={item.link0ClassName ?? "btn btn-white"} {...(typeof testPlanSection4sLinkProps === "function" ? testPlanSection4sLinkProps(item) : (testPlanSection4sLinkProps ?? {}))} {...(typeof divDiv0Div0Div0Link0LinkProps === "function" ? divDiv0Div0Div0Link0LinkProps(item) : (divDiv0Div0Div0Link0LinkProps ?? {}))}>
                                                    {item.link0Text}
                                                    <i className={item.i0ClassName ?? "isax isax-arrow-right-1"} />
                                                </SmartLink>
                                            ))}
                                        </div>
                                    </div>
                                    {renderItemNode(testPlanSection4sImageVisible, testPlanSection4sImageRenderer, item, (
                                        <SmartImage src={item.src} alt={item.alt ?? "icon"} className={item.imageWithBasePath0ClassName} {...(typeof testPlanSection4sImageProps === "function" ? testPlanSection4sImageProps(item) : (testPlanSection4sImageProps ?? {}))} {...(typeof divDiv0ImageWithBasePath0ImageProps === "function" ? divDiv0ImageWithBasePath0ImageProps(item) : (divDiv0ImageWithBasePath0ImageProps ?? {}))} />
                                    ))}
                                    {renderItemNode(testPlanSection4sImageVisible, testPlanSection4sImageRenderer, item, (
                                        <SmartImage src={item.imageWithBasePath1Src} alt={item.imageWithBasePath1Alt ?? "icon"} className={item.imageWithBasePath1ClassName ?? "img-fluid plan-img-1"} {...(typeof testPlanSection4sImageProps === "function" ? testPlanSection4sImageProps(item) : (testPlanSection4sImageProps ?? {}))} {...(typeof divDiv0ImageWithBasePath1ImageProps === "function" ? divDiv0ImageWithBasePath1ImageProps(item) : (divDiv0ImageWithBasePath1ImageProps ?? {}))} />
                                    ))}
                                </div>
                            </div>
                        ),
                        testPlanSection4sItemWrapper,
                        testPlanSection4sRenderer
                    )}
                </div>
            </div>
            <div className="icon-2"></div>
            <div className="icon-3"></div>
        </section>
    );
};

export default HomeTwelveTestPlanSectionGenerated;
